const validateTagsSize = (value) => {
  if (!value) return true

  const tags = value.split(',')

  const isAnyTagTooLong = tags.some((tag) => tag.trim().length > 30)

  if (value.trim() === '') return 'Digite algo válido'

  return (
    !isAnyTagTooLong || 'Cada classificador deve ter no máximo 30 caracteres.'
  )
}

export default validateTagsSize
